
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as openTM6zYxGZFsJ8aJ8WyZAazHLalbimPPQ_4532igS1Auj8wMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/viennazuckerl/pages/open.vue?macro=true";
import { default as index46x5tbofVBTlM_45n52HLjSUCS_XyMZ4opQGz9SixshykMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/index.vue?macro=true";
import { default as faqVwbF65T549YfBEoYxlucp__45gPWCk_45nX7ukSZ1AGiA3wMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/me/faq.vue?macro=true";
import { default as open8sohv5YkIHk0N_45lv4QGDe3ix8X9qkaxVJIuXT184MCkMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/me/open.vue?macro=true";
import { default as friends7SgaVC4sOorJEdqDNbbzwPlUz0rNEfxt4_45xoMjObBpUMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/me/friends.vue?macro=true";
import { default as overviewVBxLpCfVjsgoTIW7z4FFvZlbFXapPmt5wshaTiP8NP8Meta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/me/overview.vue?macro=true";
import { default as main86y705CFcWhi3uP3_DvCO3hb7kdaC6ujEgaXKrcydt8Meta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/widget/main.vue?macro=true";
import { default as quizSH_2vy7Vgo5YXz3QLnV_45HzZjfRyfaVK4uolUn8gP2kgMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/widget/quiz.vue?macro=true";
import { default as user96OHiAG0gQ3hU76iXiU_45l79Ld0Hu_tcyga2rdNHDvmAMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/widget/user.vue?macro=true";
import { default as challenges5N_456Jr3AMSLfw_45Rg86oGZoksyFKuj8pmx22p1pz6mTcMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/viennazuckerl/pages/me/challenges.vue?macro=true";
import { default as _91id_93MS8sgwTMe_uAMJipfbeuPZaTzSigsa7SEbgjXB_Uv74Meta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/me/posts/[id].vue?macro=true";
import { default as leaderboardqmpA3VtpgAGc3uAJgLBSgKnOteJWYcx5otFjLZs9gCMMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/me/leaderboard.vue?macro=true";
import { default as moreFriendsikzjFzXFBNhcZfDAex16i9etH8VHQWXR1lzOWJGbluUMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/me/moreFriends.vue?macro=true";
import { default as profilexhBNJVOPhnN0OTGob8yuNFhqpzLf7p24baR9QMHrSNMMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/widget/profile.vue?macro=true";
import { default as _91id_93QqpAxSrpj14_45fT8OD3tgv7emvDFuLLiMETdcJbfspL4Meta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/me/voucher/[id].vue?macro=true";
import { default as index8uI2Lv_45Bp_OAujxcW8jm8bhfAmETxTnBpu8yWeCR094Meta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/me/profile/index.vue?macro=true";
import { default as indexGD_SJADaFp5E4FXJ6cRYdZ6Q5OfFNpIjZVU3XYcpICIMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/me/rewards/index.vue?macro=true";
import { default as vplusl31cmICC3hH6hveisQi_45Hxyt32FbXFjQrW1eblBSVpsMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/me/rewards/vplus.vue?macro=true";
import { default as indexSQe5cT2n_3FYXil7EVQJvT_4587CTS2AYT7OdRHgCdjSUMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/me/voucher/index.vue?macro=true";
import { default as avatarp6SbIxspg8_Hv6P9INXnoVpJ5Ms19R639lcz_56UA4wMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/me/profile/avatar.vue?macro=true";
import { default as _91slug_93M7y98aK75qD8nw_bqjSgj83Vgold1B3hD8DqNl9hdJIMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/me/special/[slug].vue?macro=true";
import { default as prizewheelP7J4EHjN0FLIYZ9kppyXhWfXJbItgymkeNjRsD2nwgsMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/widget/prizewheel.vue?macro=true";
import { default as rewardskyUKLgieWQyuDxLWTtz22t1SJknox_458kbkrQdwcdrIsMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/me/profile/rewards.vue?macro=true";
import { default as badgeODfBLnl0TTHsQBuY3vzEtSIw8NOZzNI6Rc9nyvNeUjsMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/notification/badge.vue?macro=true";
import { default as _91id_93c0pf89WSRH4sRB4RMHItjmY8FzQUI_1gbw85QcirL8YMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/widget/reward/[id].vue?macro=true";
import { default as _91id_93MFPw_45LzDp1rNHXDLHV_45edFrNJmgWRVOKCErrLTWtU6EMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/preview/[type]/[id].vue?macro=true";
import { default as indexuB0hfFcEm5vhae2KsfxPTFXBDNql0cgouts78VnzjwgMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/widget/reward/index.vue?macro=true";
import { default as levelupKbnX8kyJPXM2BIEy9Vpu8U_456H20AhRoTYR2tn69hqO8Meta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/notification/levelup.vue?macro=true";
import { default as profileJO2NbI9z7HRdLmEABaZNCXUqGEvM_45CRtPNUHRVjdF7cMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/notification/profile.vue?macro=true";
import { default as index2oliRkW5jyqrwGydNAS3_OGyVmRZQo01U3YQaOpaWaIMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/widget/special/index.vue?macro=true";
import { default as birthdayFohODUz9l4kpC3Yz6p_EXyd2vOo8diBPblbgzQM4Pa8Meta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/viennazuckerl/pages/notification/birthday.vue?macro=true";
import { default as registerkqTKII9wQF9xNkhqM35_450YAtNuy5YNDCR4UdBxUx2mcMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/notification/register.vue?macro=true";
import { default as simpleYl2PHTWMhTa9sbAfiYaCn4cfvbYzvT2q_w4vZ9Sj8NIMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/widget/special/simple.vue?macro=true";
import { default as _91id_93mBOTIoIOvaeaOvVCNu2ruA73_45hRuc9CvPGLTozOjNZ4Meta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/me/rewards/detail/[id].vue?macro=true";
import { default as christmas_HYYQeVj3uuTnWMkDK_45hOjRbQhHgxa3y8ujvw0SN6YoMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/viennazuckerl/pages/notification/christmas.vue?macro=true";
import { default as detailFDedZploN4_45dzFURH8GHTJ_SDsK9lS7SrCdJnxmUpqAMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/preview/rewards/detail.vue?macro=true";
import { default as indexX_45APH80DZgRUoO_45PpdEVecGIFoUtIyVSEirGAUwtwygMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/widget/post/[id]/index.vue?macro=true";
import { default as specialdaytDy2Rgi5mPOe_451NDEIebOFGl4rwH5sQPqu6bBo15cCgMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/notification/specialday.vue?macro=true";
import { default as _91id_93sIO8E4HjWUlJZaChRVdzm7hN5sciqHeuJ3uE1PSZT4cMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/notification/detail/[id].vue?macro=true";
import { default as special4Kp5RjKYhpmP7rL5WHt0s3Lv0Tsw83eOEFF_YsBaXAQMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/preview/specials/special.vue?macro=true";
import { default as birthdayweekRoiIAhxElU_45bqfeBbxXLN6Z5_EbSij6ZLqbcXUC_y0UMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/viennazuckerl/pages/notification/birthdayweek.vue?macro=true";
import { default as largecardEVFFA_IO1qEQxuwZF0_45nWJI5Ax1njyjh60YoJQ92WzkMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/preview/rewards/largecard.vue?macro=true";
import { default as smallcardqNCKfW4VEyFN1_DiEmeUQRwAWGBYZjjYhNuwAJWP21oMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/preview/rewards/smallcard.vue?macro=true";
import { default as popupcPkIpgBKen2pL_45Q_45uw8KJB0VhqEUF8XyWFaxOtj1GVsMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/preview/notifications/popup.vue?macro=true";
import { default as _91id_93NR6Kig_6n5P90HR9nYaG669jx3QaQ7O42J6kqO0MAAoMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/me/rewards/detail/coupon/[id].vue?macro=true";
import { default as _91id_93cY16ckmiH53P_45pMOGj9U3J3jBVjUSkxAykXH98kMvC4Meta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/me/rewards/detail/custom/[id].vue?macro=true";
export default [
  {
    name: "open",
    path: "/open",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/viennazuckerl/pages/open.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/index.vue")
  },
  {
    name: "me-faq",
    path: "/me/faq",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/me/faq.vue")
  },
  {
    name: "me-open",
    path: "/me/open",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/me/open.vue")
  },
  {
    name: "me-friends",
    path: "/me/friends",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/me/friends.vue")
  },
  {
    name: "me-overview",
    path: "/me/overview",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/me/overview.vue")
  },
  {
    name: "widget-main",
    path: "/widget/main",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/widget/main.vue")
  },
  {
    name: "widget-quiz",
    path: "/widget/quiz",
    meta: quizSH_2vy7Vgo5YXz3QLnV_45HzZjfRyfaVK4uolUn8gP2kgMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/widget/quiz.vue")
  },
  {
    name: "widget-user",
    path: "/widget/user",
    meta: user96OHiAG0gQ3hU76iXiU_45l79Ld0Hu_tcyga2rdNHDvmAMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/widget/user.vue")
  },
  {
    name: "me-challenges",
    path: "/me/challenges",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/viennazuckerl/pages/me/challenges.vue")
  },
  {
    name: "me-posts-id",
    path: "/me/posts/:id()",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/me/posts/[id].vue")
  },
  {
    name: "me-leaderboard",
    path: "/me/leaderboard",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/me/leaderboard.vue")
  },
  {
    name: "me-moreFriends",
    path: "/me/moreFriends",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/me/moreFriends.vue")
  },
  {
    name: "widget-profile",
    path: "/widget/profile",
    meta: profilexhBNJVOPhnN0OTGob8yuNFhqpzLf7p24baR9QMHrSNMMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/widget/profile.vue")
  },
  {
    name: "me-voucher-id",
    path: "/me/voucher/:id()",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/me/voucher/[id].vue")
  },
  {
    name: "me-profile",
    path: "/me/profile",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/me/profile/index.vue")
  },
  {
    name: "me-rewards",
    path: "/me/rewards",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/me/rewards/index.vue")
  },
  {
    name: "me-rewards-vplus",
    path: "/me/rewards/vplus",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/me/rewards/vplus.vue")
  },
  {
    name: "me-voucher",
    path: "/me/voucher",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/me/voucher/index.vue")
  },
  {
    name: "me-profile-avatar",
    path: "/me/profile/avatar",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/me/profile/avatar.vue")
  },
  {
    name: "me-special-slug",
    path: "/me/special/:slug()",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/me/special/[slug].vue")
  },
  {
    name: "widget-prizewheel",
    path: "/widget/prizewheel",
    meta: prizewheelP7J4EHjN0FLIYZ9kppyXhWfXJbItgymkeNjRsD2nwgsMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/widget/prizewheel.vue")
  },
  {
    name: "me-profile-rewards",
    path: "/me/profile/rewards",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/me/profile/rewards.vue")
  },
  {
    name: "notification-badge",
    path: "/notification/badge",
    meta: badgeODfBLnl0TTHsQBuY3vzEtSIw8NOZzNI6Rc9nyvNeUjsMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/notification/badge.vue")
  },
  {
    name: "widget-reward-id",
    path: "/widget/reward/:id()",
    meta: _91id_93c0pf89WSRH4sRB4RMHItjmY8FzQUI_1gbw85QcirL8YMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/widget/reward/[id].vue")
  },
  {
    name: "preview-type-id",
    path: "/preview/:type()/:id()",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/preview/[type]/[id].vue")
  },
  {
    name: "widget-reward",
    path: "/widget/reward",
    meta: indexuB0hfFcEm5vhae2KsfxPTFXBDNql0cgouts78VnzjwgMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/widget/reward/index.vue")
  },
  {
    name: "notification-levelup",
    path: "/notification/levelup",
    meta: levelupKbnX8kyJPXM2BIEy9Vpu8U_456H20AhRoTYR2tn69hqO8Meta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/notification/levelup.vue")
  },
  {
    name: "notification-profile",
    path: "/notification/profile",
    meta: profileJO2NbI9z7HRdLmEABaZNCXUqGEvM_45CRtPNUHRVjdF7cMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/notification/profile.vue")
  },
  {
    name: "widget-special",
    path: "/widget/special",
    meta: index2oliRkW5jyqrwGydNAS3_OGyVmRZQo01U3YQaOpaWaIMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/widget/special/index.vue")
  },
  {
    name: "notification-birthday",
    path: "/notification/birthday",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/viennazuckerl/pages/notification/birthday.vue")
  },
  {
    name: "notification-register",
    path: "/notification/register",
    meta: registerkqTKII9wQF9xNkhqM35_450YAtNuy5YNDCR4UdBxUx2mcMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/notification/register.vue")
  },
  {
    name: "widget-special-simple",
    path: "/widget/special/simple",
    meta: simpleYl2PHTWMhTa9sbAfiYaCn4cfvbYzvT2q_w4vZ9Sj8NIMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/widget/special/simple.vue")
  },
  {
    name: "me-rewards-detail-id",
    path: "/me/rewards/detail/:id()",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/me/rewards/detail/[id].vue")
  },
  {
    name: "notification-christmas",
    path: "/notification/christmas",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/viennazuckerl/pages/notification/christmas.vue")
  },
  {
    name: "preview-rewards-detail",
    path: "/preview/rewards/detail",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/preview/rewards/detail.vue")
  },
  {
    name: "widget-post-id",
    path: "/widget/post/:id()",
    meta: indexX_45APH80DZgRUoO_45PpdEVecGIFoUtIyVSEirGAUwtwygMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/widget/post/[id]/index.vue")
  },
  {
    name: "notification-specialday",
    path: "/notification/specialday",
    meta: specialdaytDy2Rgi5mPOe_451NDEIebOFGl4rwH5sQPqu6bBo15cCgMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/notification/specialday.vue")
  },
  {
    name: "notification-detail-id",
    path: "/notification/detail/:id()",
    meta: _91id_93sIO8E4HjWUlJZaChRVdzm7hN5sciqHeuJ3uE1PSZT4cMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/notification/detail/[id].vue")
  },
  {
    name: "preview-specials-special",
    path: "/preview/specials/special",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/preview/specials/special.vue")
  },
  {
    name: "notification-birthdayweek",
    path: "/notification/birthdayweek",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/viennazuckerl/pages/notification/birthdayweek.vue")
  },
  {
    name: "preview-rewards-largecard",
    path: "/preview/rewards/largecard",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/preview/rewards/largecard.vue")
  },
  {
    name: "preview-rewards-smallcard",
    path: "/preview/rewards/smallcard",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/preview/rewards/smallcard.vue")
  },
  {
    name: "preview-notifications-popup",
    path: "/preview/notifications/popup",
    meta: popupcPkIpgBKen2pL_45Q_45uw8KJB0VhqEUF8XyWFaxOtj1GVsMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/preview/notifications/popup.vue")
  },
  {
    name: "me-rewards-detail-coupon-id",
    path: "/me/rewards/detail/coupon/:id()",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/me/rewards/detail/coupon/[id].vue")
  },
  {
    name: "me-rewards-detail-custom-id",
    path: "/me/rewards/detail/custom/:id()",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/pages/me/rewards/detail/custom/[id].vue")
  }
]